import moment from 'moment';
import { I18n } from 'react-redux-i18n';
import { groupData } from './common';

export function extractNotationData(list) {
  const byString = I18n.t('dashboard.feedDescriptions.by');

  const sortKeysHashMap = {
    date: 'originalDate',
    journalist_name: 'journalist_name',
    journal_country_name: 'origin'
  };

  const sameFunc = (acc, curr) => {
    const previous = acc[acc.length - 1];
    previous.descriptionList.push(
      `${curr.wine_name} ${curr.vintage} : ${curr.displayed_note} ${byString} ${curr.journalist_name}`
    );
    acc[acc.length - 1] = previous;
    return acc;
  };

  const diffFunc = (acc, curr) => {
    const momentDate = moment(curr.date, 'YYYY-MM-DD');
    const item = {
      ...curr,
      type: 'notation',
      order: 2,
      title: I18n.t('dashboard.feedTitles.notes'),
      link: '/communication/notes',
      origin: curr.journal_country_name,
      originalDate: curr.date,
      date: momentDate.format('DD/MM/YYYY'),
      momentDate,
      descriptionList: [
        `${curr.wine_name} ${curr.vintage} : ${curr.displayed_note} ${byString} ${curr.journalist_name}`
      ]
    };
    acc.push(item);
    return acc;
  };

  return groupData(list, sortKeysHashMap, sameFunc, diffFunc);
}
